<template>
  <div class="container">
    <h1>New Image</h1>
    <hr>
    <image-form v-on:save-image="patchData()" :item="item" :errors="errors"></image-form>
    <p class="text-center">
      <button type="button" class="btn btn-primary" @click="postData()">Save</button>
      <router-link class="btn btn-secondary" :to="`/images`">Cancel</router-link>
    </p>
  </div>
</template>

<script>
import ImageForm from "@/components/image/_Form";
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "../../lib/axios";
import { ObjectID } from "bson";

export default {
  name: "image-new",
  components: {
    ImageForm
  },
  data() {
    return {
      item: {
        file: null,
        description: null
      },
      errors: {}
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      user: state => state.session.user
    })
  },
  mounted() {
    this.$Progress.finish();
    this.$embers.pageData("New Image");
  },
  methods: {
    ...mapActions({
      imagesCreate: "images/create"
    }),
    async uploadImage(payload) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", payload.signedRequest);
        xhr.setRequestHeader("Content-Type", payload.file.type);
        xhr.onreadystatechange = async () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              reject(xhr.response);
            }
          }
        };
        xhr.send(payload.file);
      });
    },
    s3Key(userId, ext) {
      let imageId = new ObjectID().toString();
      return `${userId}/${imageId}.${ext}`;
    },
    async postData() {
      try {
        if (!this.item.file) return;
        // GET s3 SIGNED PUT URL
        let s3key = this.s3Key(
          this.user._id,
          this.item.file.type.split("/")[1]
        );
        let signedUrlPut = await axios.post(`/s3/signedUrl`, {
          key: s3key,
          type: this.item.file.type,
          size: this.item.file.size
        });

        // UPLOAD IMAGE
        await this.uploadImage({
          signedRequest: signedUrlPut.data.signedRequest,
          file: this.item.file
        });

        // CREATE IMAGE RECORD
        let item = await this.imagesCreate({
          key: s3key,
          size: this.item.file.size,
          type: this.item.file.type,
          url: signedUrlPut.data.url,
          description: this.item.description
        });
        this.$router.push({ path: `/images/${item._id}` });
      } catch (err) {
        console.error(err.response.data);
        this.errors = Object.assign({}, this.errors, err.response.data);
      }
    }
  }
};
</script>
